import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { KeyValue } from '../models/common';
import { IAddressTypeApi } from './base';

const baseRoute: string = 'AddressType';

export class AddressTypeApi extends IAddressTypeApi {
  getDomainPublic(): Promise<AxiosResponse<Result<KeyValue[]>, any>> {
    return api.get(`${baseRoute}/addresstypedomain_public`);
  }
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }
}
